// removed by extract-text-webpack-plugin
module.exports = {"SelectClient_div":"SelectClient__SelectClient_div___2BpWD"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/admin/stockStoreUpdate/components/SelectClient.css
// module id = 1072
// module chunks = 0